import React from "react";
import ReactDom from "react-dom";

import {observable, action, computed} from 'mobx';
import {observer} from 'mobx-react';

import {Decorator as editable} from 'simbox-editable';

import autoclass from 'autoclass-decorator';

import BaseViewStore from 'base-viewstore';
import BaseComponent from 'base-component';

// this is like a ViewModel, contains all user actions for this component
export class ExampleViewStore extends BaseViewStore{
  // validation is a derivation
  @computed get invalid(){
    const invalid = {};
    const {
      contentModel: activity,
      inputStore: {
        getInput,
        setInput
      }
    } = this.props;

    const userInputValue = getInput(activity, "userInput")

    if(!userInputValue) invalid.userInput = "User, please provide a value!"

    return invalid;
  }  
  @action.bound save(){
    const {
      contentModel: activity,
      inputStore: {
        saveData,
        setInput
      }
    } = this.props;    
    setInput( activity, "isCompleted", true );
    saveData( () => console.log(this.id + " saved!") )
  }
}

@editable // this makes the view editable via authoring tool via data-editable
@observer // mobx manages this view
@autoclass // this automatically gives consistent `className`s to components using module and component names
export class Example extends BaseComponent{
  static ViewStore = ExampleViewStore; //ViewStore gets auto-instantiated and attached to the component on creation
  render(){
    const {
      currentView, // the parent view container, may have options etc attached depending on context
      contentModel, // the hydrated contentModel
      inputStore: {
        getInput,
        setInput,
        isDirty,
        isLoading,
        revert
      }
    } = this.props;

    const {
      textSlot,
      richTextSlot,
      textOptionsSlot,
      numberSlot,
      booleanSlot,
      referenceSlot,
      referenceArraySlot
    } = contentModel; // this contentModel's properties

    const {
      invalid,
      save
    } = this.viewStore; // this components viewStore.  Will have actions and UI properties

    function createMarkup(html) {
      return {__html: html};
    }

    if(isLoading) return <div>Loading...</div>

    return (<div>
      <div className="header">
        <h2 className="title">{textOptionsSlot} - {numberSlot}</h2>
        <div className="subtitle">{textSlot}</div>
        {!!booleanSlot && <div className="boolean">Boolean selected</div>}
      </div>
      <div className="content-area">      
        <div className="left-column">
          <div dangerouslySetInnerHTML={createMarkup(richTextSlot)}></div>

          <hr />

          {!!invalid.userInput && <div className="validation-error">{invalid.userInput}</div>}
          <input type="text" value={getInput(contentModel, "userInput")} onChange={e => setInput(contentModel, "userInput", e.target.value) }/>

          <textarea disabled="true" value={getInput(contentModel, "userInput_computed")}></textarea>
          
          <hr />

          <button onClick={save} disabled={Object.keys(invalid).length || !isDirty}>Save</button>
          <button onClick={revert} disabled={!isDirty}>Undo</button>

        </div>
        <div className="center-column">
          <div>Single / direct reference slot:</div>
          <ExampleSub data-editable={[contentModel, "referenceSlot"]} contentModel={referenceSlot} />
        </div>
        <div className="right-column" data-editable={[contentModel, "referenceArraySlot"]} >
          <div>Array of references slot:</div>
          {referenceArraySlot.map( cm => <ExampleSub key={cm.id} contentModel={cm} /> )}
        </div>
      </div>
    </div>)
  }
}
export default Example; //need to export top level component as "default"

@editable
@observer
@autoclass
export class ExampleSub extends BaseComponent{
  render(){
    const {contentModel} = this.props;
    if(!contentModel) return <div>No contentmodel supplied</div>
    const {text, richText} = contentModel;

    function createMarkup(html) {
      return {__html: html};
    }

    return <div>
      <div className="title">{text}</div>
      <div className="body" dangerouslySetInnerHTML={createMarkup(richText)}></div>
    </div>
  }
}


// WEBPACK FOOTER //
// ./app_modules/example-activity/component.js